import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Typography } from "@mui/material";
import { marked } from "marked";
import React from "react";
import FileExtensionIco from "../../../../assets/icons/FileExtensionIco";
import StarShrinkIco from "../../../../assets/icons/StarShrinkIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import FullSizeChatBot from "../../../chat-bot/FullSizeChatBot";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CommonTippy, CustomizeSpan } from "../../../jobs/style";

export default function KlarityFileData({
  breadCrumbData,
  chatBotData,
  handleChatBotChange,
  isBottomVisible,
  setIsBottomVisible,
  handleSendMessage,
  klarityData,
  handleUploadNewFile,
}) {
  return (
    <CustomDiv
      //   height={"calc(100vh - 137px)"}
      overflowY="auto"
      height="100%"
      display="flex"
      width="100%"
      gap="0.8rem"
    >
      <CustomDiv
        width={"calc(100% - 350px)"}
        margin="1.5rem 0rem 1.5rem 1.5rem"
      >
        <Breadcrumbs breadCrumbData={breadCrumbData} />

        <CommonGrid2
          border={"1px solid rgba(0, 0, 0, 0.12)"}
          borderRadius={"10px"}
          position={"relative"}
          background="#F6F8FB"
          height="calc(100% - 2rem)"
          marginTop={"10px"}
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"space-between"}
            overflow={"auto"}
            padding={"1rem"}
            height={"-webkit-fill-available"}
            scrollBar="6px"
            scrollStyle
            customStyle={{ overflowX: "hidden" }}
          >
            <CustomDiv margin="0px 0px 1rem">
              <Typography
                variant="body5"
                color="#8396A8"
                fontWeight={700}
                sx={{
                  background:
                    "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Here is the status of the Growth Agent
                <CustomizeSpan margin="0px 0px 0px 8px">
                  <StarShrinkIco />
                </CustomizeSpan>
              </Typography>
            </CustomDiv>
            <FullSizeChatBot
              chatBotData={chatBotData}
              handleChatBotChange={handleChatBotChange}
              setIsBottomVisible={setIsBottomVisible}
              isBottomVisible={isBottomVisible}
              handleSendMessage={handleSendMessage}
              customStyle={{
                width: "calc(100% + 16px)",
                height: "calc(100vh - 16rem) !important",
                // position: "relative",
                // right: "5px",
                padding: "0px 10px 0px 5px",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
              }}
            />
          </CommonGrid2>
        </CommonGrid2>
      </CustomDiv>
      <CommonGrid2
        width={"350px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        top={"0px"}
        position={"sticky"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        background="#F6F8FB"
        scrollBar="5px"
      >
        <CommonGrid2
          item
          padding={"1rem"}
          overflowY={"scroll"}
          scrollStyle
          displayBar="none"
        >
          <CommonGrid2 display={"flex"} gap={"0rem"} flexDirection={"column"}>
            <CommonGrid2
              display={"flex"}
              gap={"10px"}
              margin={"12px 0px 5px"}
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Typography variant="body4" fontWeight={600}>
                Recent Growth Agent
              </Typography>
              <CommonButton
                width={"fit-content"}
                variant="outlined"
                color="#344054"
                border="#D0D5DD"
                fontWeight="700"
                value={"Upload New File"}
                padding={"5px 12px"}
                fontSize={"12px"}
                gap={"0px"}
                disabled={klarityData.loading}
                onClick={handleUploadNewFile}
                startIcon={<CloudUploadIcon />}
                boxShadow={"none"}
                customStyle={{
                  flexDirection: "column",
                }}
              />
            </CommonGrid2>
            <CommonGrid2
              marginTop={"1rem"}
              display={"flex"}
              flexDirection="column"
              scrollStyle
              overflow={"auto"}
              width={"calc(100% + 20px)"}
              height="calc(100vh - 8rem)"
              left={"-6px"}
              paddingRight={"10px"}
              position={"relative"}
              scrollBar="5px"
            >
              {klarityData.loading ? (
                <HandleSkeletion height={70} marginTop="1rem" />
              ) : (
                <>
                  <CommonTippy
                    content={klarityData?.data_status?.file_name}
                    placement="top"
                    color={"#7F56D9"}
                    fontSize="12px"
                    bottom={"5px"}
                  >
                    <CommonGrid2
                      background={"#EBE1F9"}
                      color={"#6947B0"}
                      display="flex"
                      gap="10px"
                      padding="5px 10px"
                      alignItems="center"
                      borderRadius="5px"
                      border={"1px solid"}
                    >
                      <CustomDiv display="flex">
                        <FileExtensionIco
                          extension={"XLS"}
                          extensionColor={"#16A34A"}
                          width="28px"
                        />
                      </CustomDiv>
                      <Typography
                        sx={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {klarityData?.data?.file_name ||
                          klarityData?.data_status?.file_name}
                      </Typography>
                    </CommonGrid2>
                  </CommonTippy>
                  <div
                    className="markdown-content"
                    dangerouslySetInnerHTML={{
                      __html: marked(klarityData?.data?.file_summary || ""),
                    }}
                    style={{
                      fontFamily: "Arial",
                      fontSize: 13,
                      marginTop: "1rem",
                    }}
                  />
                </>
              )}
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
    </CustomDiv>
  );
}
